import React, { useEffect } from "react";
import { BehaviorSubject } from "rxjs";

export const DEFAULT_HEADER = <React.Fragment />;
export const subjectHeader = new BehaviorSubject(DEFAULT_HEADER);

export default function useSetHeader(header) {
  useEffect(() => {
    subjectHeader.next(header);

    return () => subjectHeader.next(DEFAULT_HEADER);
  }, [header]);
}
